import { EventType } from '@/features/events/shared'
import type { ConversationTurnEntry } from '@/features/events/conversation/state/types'
import type { BlockingBucket } from '../types'

export function resolveBlockingBucket(event: ConversationTurnEntry): BlockingBucket {
  switch (event.eventType) {
    case EventType.TOOL_PERMISSION_REQUEST:
      return EventType.TOOL_PERMISSION_REQUEST
    case EventType.PLAN_APPROVAL_REQUEST:
      return EventType.PLAN_APPROVAL_REQUEST
    case EventType.AGENT_QUESTIONS:
      return EventType.AGENT_QUESTIONS
    default:
      return EventType.ERRORED_EVENT
  }
}
